/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import {HttpClient, HttpContext, HttpParams} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseServiceUrl } from '../base-service-url';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addEvent } from '../fn/harvest/add-event';
import { addEvent_1 } from '../fn/harvest/add-event-1';
import { AddEvent_1$Params } from '../fn/harvest/add-event-1';
import { AddEvent$Params } from '../fn/harvest/add-event';
import { closeHarvest } from '../fn/harvest/close-harvest';
import { CloseHarvest$Params } from '../fn/harvest/close-harvest';
import { createHarvest } from '../fn/harvest/create-harvest';
import { CreateHarvest$Params } from '../fn/harvest/create-harvest';
import { deleteEvent } from '../fn/harvest/delete-event';
import { DeleteEvent$Params } from '../fn/harvest/delete-event';
import { DeviceInUseDto } from '../models/device-in-use-dto';
import { EnvironmentalReadingResponse } from '../models/environmental-reading-response';
import { EventCreateResponseDto } from '../models/event-create-response-dto';
import { FacilityHarvestDto } from '../models/facility-harvest-dto';
import { FeaturesDto } from '../models/features-dto';
import { getDefaults } from '../fn/harvest/get-defaults';
import { getDefaults_1 } from '../fn/harvest/get-defaults-1';
import { GetDefaults_1$Params } from '../fn/harvest/get-defaults-1';
import { GetDefaults$Params } from '../fn/harvest/get-defaults';
import { getEnvironmentalReadings } from '../fn/harvest/get-environmental-readings';
import { GetEnvironmentalReadings$Params } from '../fn/harvest/get-environmental-readings';
import { getEvents } from '../fn/harvest/get-events';
import { GetEvents$Params } from '../fn/harvest/get-events';
import { getFacilityGroupEvents } from '../fn/harvest/get-facility-group-events';
import { GetFacilityGroupEvents$Params } from '../fn/harvest/get-facility-group-events';
import { getFeatures } from '../fn/harvest/get-features';
import { GetFeatures$Params } from '../fn/harvest/get-features';
import { getFullHarvest } from '../fn/harvest/get-full-harvest';
import { GetFullHarvest$Params } from '../fn/harvest/get-full-harvest';
import { getGroupDevices } from '../fn/harvest/get-group-devices';
import { GetGroupDevices$Params } from '../fn/harvest/get-group-devices';
import { getHarvestCreateAuxiliaryDataResponse } from '../fn/harvest/get-harvest-create-auxiliary-data-response';
import { GetHarvestCreateAuxiliaryDataResponse$Params } from '../fn/harvest/get-harvest-create-auxiliary-data-response';
import { getHarvestFullResponse } from '../fn/harvest/get-harvest-full-response';
import { GetHarvestFullResponse$Params } from '../fn/harvest/get-harvest-full-response';
import { getHarvests } from '../fn/harvest/get-harvests';
import { GetHarvests$Params } from '../fn/harvest/get-harvests';
import { getLastHarvestsForFacilityGroup } from '../fn/harvest/get-last-harvests-for-facility-group';
import { GetLastHarvestsForFacilityGroup$Params } from '../fn/harvest/get-last-harvests-for-facility-group';
import { getMortality } from '../fn/harvest/get-mortality';
import { GetMortality$Params } from '../fn/harvest/get-mortality';
import { getMortalityAnalysisData } from '../fn/harvest/get-mortality-analysis-data';
import { GetMortalityAnalysisData$Params } from '../fn/harvest/get-mortality-analysis-data';
import { getMortalityWidgetResponse } from '../fn/harvest/get-mortality-widget-response';
import { GetMortalityWidgetResponse$Params } from '../fn/harvest/get-mortality-widget-response';
import { getWaterConsumptionPerformace } from '../fn/harvest/get-water-consumption-performace';
import { GetWaterConsumptionPerformace$Params } from '../fn/harvest/get-water-consumption-performace';
import { HarvestBasicResponse } from '../models/harvest-basic-response';
import { HarvestCreateAuxiliaryDataResponse } from '../models/harvest-create-auxiliary-data-response';
import { HarvestCustomerDefaultsDto } from '../models/harvest-customer-defaults-dto';
import { HarvestDto } from '../models/harvest-dto';
import { HarvestEventDto } from '../models/harvest-event-dto';
import { HarvestFullResponse } from '../models/harvest-full-response';
import { MortalityAnalysisResponse } from '../models/mortality-analysis-response';
import { MortalityResponse } from '../models/mortality-response';
import { MortalityTableRow } from '../models/mortality-table-row';
import { MortalityWidgetResponse } from '../models/mortality-widget-response';
import { putMortality } from '../fn/harvest/put-mortality';
import { PutMortality$Params } from '../fn/harvest/put-mortality';
import { updateDefaults } from '../fn/harvest/update-defaults';
import { UpdateDefaults$Params } from '../fn/harvest/update-defaults';
import { updateEvent } from '../fn/harvest/update-event';
import { UpdateEvent$Params } from '../fn/harvest/update-event';
import { updateFeatures } from '../fn/harvest/update-features';
import { UpdateFeatures$Params } from '../fn/harvest/update-features';
import { updateFeed } from '../fn/harvest/update-feed';
import { UpdateFeed$Params } from '../fn/harvest/update-feed';
import { updateGroupDevices } from '../fn/harvest/update-group-devices';
import { updateGroupDevices_1 } from '../fn/harvest/update-group-devices-1';
import { UpdateGroupDevices_1$Params } from '../fn/harvest/update-group-devices-1';
import { UpdateGroupDevices$Params } from '../fn/harvest/update-group-devices';
import { updateHarvest } from '../fn/harvest/update-harvest';
import { UpdateHarvest$Params } from '../fn/harvest/update-harvest';
import { WaterConsumptionDto } from '../models/water-consumption-dto';

@Injectable({ providedIn: 'root' })
export class HarvestService extends BaseServiceUrl {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createHarvest()` */
  static readonly CreateHarvestPath = '/api/harvests';

  /**
   * Create Harvest.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createHarvest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createHarvest$Response(params: CreateHarvest$Params, context?: HttpContext): Observable<StrictHttpResponse<HarvestFullResponse>> {
    return createHarvest(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Harvest.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createHarvest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createHarvest(params: CreateHarvest$Params, context?: HttpContext): Observable<HarvestFullResponse> {
    return this.createHarvest$Response(params, context).pipe(
      map((r: StrictHttpResponse<HarvestFullResponse>): HarvestFullResponse => r.body)
    );
  }

  /** Path part for operation `getHarvestCreateAuxiliaryDataResponse()` */
  static readonly GetHarvestCreateAuxiliaryDataResponsePath = '/api/harvests/auxiliary-data';

  /**
   * Get Harvest Create Auxiliary Data Response.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHarvestCreateAuxiliaryDataResponse()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHarvestCreateAuxiliaryDataResponse$Response(params?: GetHarvestCreateAuxiliaryDataResponse$Params, context?: HttpContext): Observable<StrictHttpResponse<HarvestCreateAuxiliaryDataResponse>> {
    return getHarvestCreateAuxiliaryDataResponse(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Harvest Create Auxiliary Data Response.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getHarvestCreateAuxiliaryDataResponse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHarvestCreateAuxiliaryDataResponse(params?: GetHarvestCreateAuxiliaryDataResponse$Params, context?: HttpContext): Observable<HarvestCreateAuxiliaryDataResponse> {
    return this.getHarvestCreateAuxiliaryDataResponse$Response(params, context).pipe(
      map((r: StrictHttpResponse<HarvestCreateAuxiliaryDataResponse>): HarvestCreateAuxiliaryDataResponse => r.body)
    );
  }

  /** Path part for operation `getDefaults()` */
  static readonly GetDefaultsPath = '/api/harvests/defaults';

  /**
   * Get Defaults.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDefaults()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDefaults$Response(params?: GetDefaults$Params, context?: HttpContext): Observable<StrictHttpResponse<HarvestCustomerDefaultsDto>> {
    return getDefaults(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Defaults.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDefaults$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDefaults(params?: GetDefaults$Params, context?: HttpContext): Observable<HarvestCustomerDefaultsDto> {
    return this.getDefaults$Response(params, context).pipe(
      map((r: StrictHttpResponse<HarvestCustomerDefaultsDto>): HarvestCustomerDefaultsDto => r.body)
    );
  }

  /** Path part for operation `updateDefaults()` */
  static readonly UpdateDefaultsPath = '/api/harvests/defaults';

  /**
   * Update Defaults.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateDefaults()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDefaults$Response(params: UpdateDefaults$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateDefaults(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Defaults.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateDefaults$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDefaults(params: UpdateDefaults$Params, context?: HttpContext): Observable<void> {
    return this.updateDefaults$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getDefaults_1()` */
  static readonly GetDefaults_1Path = '/api/harvests/defaults-values';

  /**
   * Get Defaults.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDefaults_1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDefaults_1$Response(params?: GetDefaults_1$Params, context?: HttpContext): Observable<StrictHttpResponse<HarvestCustomerDefaultsDto>> {
    return getDefaults_1(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Defaults.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDefaults_1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDefaults_1(params?: GetDefaults_1$Params, context?: HttpContext): Observable<HarvestCustomerDefaultsDto> {
    return this.getDefaults_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<HarvestCustomerDefaultsDto>): HarvestCustomerDefaultsDto => r.body)
    );
  }

  /** Path part for operation `addEvent()` */
  static readonly AddEventPath = '/api/harvests/event';

  /**
   * Add Event.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addEvent()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addEvent$Response(params: AddEvent$Params, context?: HttpContext): Observable<StrictHttpResponse<EventCreateResponseDto>> {
    return addEvent(this.http, this.rootUrl, params, context);
  }

  /**
   * Add Event.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addEvent$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addEvent(params: AddEvent$Params, context?: HttpContext): Observable<EventCreateResponseDto> {
    return this.addEvent$Response(params, context).pipe(
      map((r: StrictHttpResponse<EventCreateResponseDto>): EventCreateResponseDto => r.body)
    );
  }

  /** Path part for operation `getFacilityGroupEvents()` */
  static readonly GetFacilityGroupEventsPath = '/api/harvests/facilityGroup/{facilityGroupId}/events';

  /**
   * Get Facility Group Events.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFacilityGroupEvents()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFacilityGroupEvents$Response(params: GetFacilityGroupEvents$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<HarvestEventDto>>> {
    return getFacilityGroupEvents(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Facility Group Events.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFacilityGroupEvents$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFacilityGroupEvents(params: GetFacilityGroupEvents$Params, context?: HttpContext): Observable<Array<HarvestEventDto>> {
    return this.getFacilityGroupEvents$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<HarvestEventDto>>): Array<HarvestEventDto> => r.body)
    );
  }

  /** Path part for operation `getHarvests()` */
  static readonly GetHarvestsPath = '/api/harvests/facilityGroupId/{facilityGroupId}';

  /**
   * Get Harvests.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHarvests()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHarvests$Response(params: GetHarvests$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<HarvestDto>>> {
    return getHarvests(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Harvests.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getHarvests$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHarvests(params: GetHarvests$Params, context?: HttpContext): Observable<Array<HarvestDto>> {
    return this.getHarvests$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<HarvestDto>>): Array<HarvestDto> => r.body)
    );
  }

  /** Path part for operation `getLastHarvestsForFacilityGroup()` */
  static readonly GetLastHarvestsForFacilityGroupPath = '/api/harvests/facilityGroupId/{facilityGroupId}/last';

  /**
   * Get Last Harvests For Facility Group.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLastHarvestsForFacilityGroup()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLastHarvestsForFacilityGroup$Response(params: GetLastHarvestsForFacilityGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<HarvestFullResponse>>> {
    return getLastHarvestsForFacilityGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Last Harvests For Facility Group.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLastHarvestsForFacilityGroup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLastHarvestsForFacilityGroup(params: GetLastHarvestsForFacilityGroup$Params, context?: HttpContext): Observable<Array<HarvestFullResponse>> {
    return this.getLastHarvestsForFacilityGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<HarvestFullResponse>>): Array<HarvestFullResponse> => r.body)
    );
  }

  /** Path part for operation `getFeatures()` */
  static readonly GetFeaturesPath = '/api/harvests/features';

  /**
   * Get Features.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFeatures()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeatures$Response(params?: GetFeatures$Params, context?: HttpContext): Observable<StrictHttpResponse<FeaturesDto>> {
    return getFeatures(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Features.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFeatures$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeatures(params?: GetFeatures$Params, context?: HttpContext): Observable<FeaturesDto> {
    return this.getFeatures$Response(params, context).pipe(
      map((r: StrictHttpResponse<FeaturesDto>): FeaturesDto => r.body)
    );
  }

  /** Path part for operation `updateFeatures()` */
  static readonly UpdateFeaturesPath = '/api/harvests/features';

  /**
   * Update Features.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateFeatures()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFeatures$Response(params: UpdateFeatures$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateFeatures(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Features.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateFeatures$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFeatures(params: UpdateFeatures$Params, context?: HttpContext): Observable<void> {
    return this.updateFeatures$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getWaterConsumptionPerformace()` */
  static readonly GetWaterConsumptionPerformacePath = '/api/harvests/waterConsumptionPerformace/{harvestId}/{deviceId}';

  /**
   * Get Water Consumption Performace.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWaterConsumptionPerformace()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWaterConsumptionPerformace$Response(params: GetWaterConsumptionPerformace$Params, context?: HttpContext): Observable<StrictHttpResponse<WaterConsumptionDto>> {
    return getWaterConsumptionPerformace(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Water Consumption Performace.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getWaterConsumptionPerformace$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWaterConsumptionPerformace(params: GetWaterConsumptionPerformace$Params, context?: HttpContext): Observable<WaterConsumptionDto> {
    return this.getWaterConsumptionPerformace$Response(params, context).pipe(
      map((r: StrictHttpResponse<WaterConsumptionDto>): WaterConsumptionDto => r.body)
    );
  }

  /** Path part for operation `getHarvestFullResponse()` */
  static readonly GetHarvestFullResponsePath = '/api/harvests/{harvestId}';

  /**
   * Get Harvest Full Response.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHarvestFullResponse()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHarvestFullResponse$Response(params: GetHarvestFullResponse$Params, context?: HttpContext): Observable<StrictHttpResponse<HarvestFullResponse>> {
    return getHarvestFullResponse(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Harvest Full Response.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getHarvestFullResponse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHarvestFullResponse(params: GetHarvestFullResponse$Params, context?: HttpContext): Observable<HarvestFullResponse> {
    return this.getHarvestFullResponse$Response(params, context).pipe(
      map((r: StrictHttpResponse<HarvestFullResponse>): HarvestFullResponse => r.body)
    );
  }

  /** Path part for operation `updateHarvest()` */
  static readonly UpdateHarvestPath = '/api/harvests/{harvestId}';

  /**
   * Update Harvest.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateHarvest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateHarvest$Response(params: UpdateHarvest$Params, context?: HttpContext): Observable<StrictHttpResponse<HarvestFullResponse>> {
    return updateHarvest(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Harvest.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateHarvest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateHarvest(params: UpdateHarvest$Params, context?: HttpContext): Observable<HarvestFullResponse> {
    return this.updateHarvest$Response(params, context).pipe(
      map((r: StrictHttpResponse<HarvestFullResponse>): HarvestFullResponse => r.body)
    );
  }

  /** Path part for operation `closeHarvest()` */
  static readonly CloseHarvestPath = '/api/harvests/{harvestId}/close-harvest';

  /**
   * Close Harvest.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `closeHarvest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  closeHarvest$Response(params: CloseHarvest$Params, context?: HttpContext): Observable<StrictHttpResponse<HarvestBasicResponse>> {
    return closeHarvest(this.http, this.rootUrl, params, context);
  }

  /**
   * Close Harvest.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `closeHarvest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  closeHarvest(params: CloseHarvest$Params, context?: HttpContext): Observable<HarvestBasicResponse> {
    return this.closeHarvest$Response(params, context).pipe(
      map((r: StrictHttpResponse<HarvestBasicResponse>): HarvestBasicResponse => r.body)
    );
  }

  /** Path part for operation `getEnvironmentalReadings()` */
  static readonly GetEnvironmentalReadingsPath = '/api/harvests/{harvestId}/environmental-readings';

  /**
   * Get Environmental Readings.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEnvironmentalReadings()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEnvironmentalReadings$Response(params: GetEnvironmentalReadings$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EnvironmentalReadingResponse>>> {
    return getEnvironmentalReadings(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Environmental Readings.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEnvironmentalReadings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEnvironmentalReadings(params: GetEnvironmentalReadings$Params, context?: HttpContext): Observable<Array<EnvironmentalReadingResponse>> {
    return this.getEnvironmentalReadings$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<EnvironmentalReadingResponse>>): Array<EnvironmentalReadingResponse> => r.body)
    );
  }

  /** Path part for operation `addEvent_1()` */
  static readonly AddEvent_1Path = '/api/harvests/{harvestId}/event';

  /**
   * Add Event.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addEvent_1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addEvent_1$Response(params: AddEvent_1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<HarvestEventDto>>> {
    return addEvent_1(this.http, this.rootUrl, params, context);
  }

  /**
   * Add Event.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addEvent_1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addEvent_1(params: AddEvent_1$Params, context?: HttpContext): Observable<Array<HarvestEventDto>> {
    return this.addEvent_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<HarvestEventDto>>): Array<HarvestEventDto> => r.body)
    );
  }

  /** Path part for operation `updateEvent()` */
  static readonly UpdateEventPath = '/api/harvests/{harvestId}/event/{eventId}';

  /**
   * Update Event.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateEvent()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateEvent$Response(params: UpdateEvent$Params, context?: HttpContext): Observable<StrictHttpResponse<HarvestEventDto>> {
    return updateEvent(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Event.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateEvent$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateEvent(params: UpdateEvent$Params, context?: HttpContext): Observable<HarvestEventDto> {
    return this.updateEvent$Response(params, context).pipe(
      map((r: StrictHttpResponse<HarvestEventDto>): HarvestEventDto => r.body)
    );
  }

  /** Path part for operation `deleteEvent()` */
  static readonly DeleteEventPath = '/api/harvests/{harvestId}/event/{eventId}';

  /**
   * Delete Event.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteEvent()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteEvent$Response(params: DeleteEvent$Params, context?: HttpContext): Observable<StrictHttpResponse<HarvestEventDto>> {
    return deleteEvent(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Event.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteEvent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteEvent(params: DeleteEvent$Params, context?: HttpContext): Observable<HarvestEventDto> {
    return this.deleteEvent$Response(params, context).pipe(
      map((r: StrictHttpResponse<HarvestEventDto>): HarvestEventDto => r.body)
    );
  }

  /** Path part for operation `getEvents()` */
  static readonly GetEventsPath = '/api/harvests/{harvestId}/events';

  /**
   * Get Events.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEvents()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEvents$Response(params: GetEvents$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<HarvestEventDto>>> {
    return getEvents(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Events.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEvents$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEvents(params: GetEvents$Params, context?: HttpContext): Observable<Array<HarvestEventDto>> {
    return this.getEvents$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<HarvestEventDto>>): Array<HarvestEventDto> => r.body)
    );
  }

  /** Path part for operation `updateFeed()` */
  static readonly UpdateFeedPath = '/api/harvests/{harvestId}/feed';

  /**
   * Update Feed.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateFeed()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFeed$Response(params: UpdateFeed$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateFeed(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Feed.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateFeed$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFeed(params: UpdateFeed$Params, context?: HttpContext): Observable<void> {
    return this.updateFeed$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  updateFeedByCSV(harvestId: number, body: FormData): Observable<Object> {
    return this.http.post(this.rootUrl + '/api/feed/upload', body, { params: new HttpParams().set('harvestId', harvestId) });
  }

  /** Path part for operation `getFullHarvest()` */
  static readonly GetFullHarvestPath = '/api/harvests/{harvestId}/full-harvest';

  /**
   * Get Full Harvest.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFullHarvest()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFullHarvest$Response(params: GetFullHarvest$Params, context?: HttpContext): Observable<StrictHttpResponse<FacilityHarvestDto>> {
    return getFullHarvest(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Full Harvest.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFullHarvest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFullHarvest(params: GetFullHarvest$Params, context?: HttpContext): Observable<FacilityHarvestDto> {
    return this.getFullHarvest$Response(params, context).pipe(
      map((r: StrictHttpResponse<FacilityHarvestDto>): FacilityHarvestDto => r.body)
    );
  }

  /** Path part for operation `updateGroupDevices()` */
  static readonly UpdateGroupDevicesPath = '/api/harvests/{harvestId}/group/devices';

  /**
   * Update Group Devices.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateGroupDevices()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateGroupDevices$Response(params: UpdateGroupDevices$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateGroupDevices(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Group Devices.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateGroupDevices$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateGroupDevices(params: UpdateGroupDevices$Params, context?: HttpContext): Observable<void> {
    return this.updateGroupDevices$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getGroupDevices()` */
  static readonly GetGroupDevicesPath = '/api/harvests/{harvestId}/group/{groupIdx}/devices';

  /**
   * Get Group Devices.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getGroupDevices()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGroupDevices$Response(params: GetGroupDevices$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DeviceInUseDto>>> {
    return getGroupDevices(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Group Devices.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getGroupDevices$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGroupDevices(params: GetGroupDevices$Params, context?: HttpContext): Observable<Array<DeviceInUseDto>> {
    return this.getGroupDevices$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DeviceInUseDto>>): Array<DeviceInUseDto> => r.body)
    );
  }

  /** Path part for operation `updateGroupDevices_1()` */
  static readonly UpdateGroupDevices_1Path = '/api/harvests/{harvestId}/group/{groupIdx}/devices';

  /**
   * Update Group Devices.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateGroupDevices_1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateGroupDevices_1$Response(params: UpdateGroupDevices_1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateGroupDevices_1(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Group Devices.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateGroupDevices_1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateGroupDevices_1(params: UpdateGroupDevices_1$Params, context?: HttpContext): Observable<void> {
    return this.updateGroupDevices_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getMortality()` */
  static readonly GetMortalityPath = '/api/harvests/{harvestId}/mortality';

  /**
   * Get Mortality.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMortality()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMortality$Response(params: GetMortality$Params, context?: HttpContext): Observable<StrictHttpResponse<MortalityResponse>> {
    return getMortality(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Mortality.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMortality$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMortality(params: GetMortality$Params, context?: HttpContext): Observable<MortalityResponse> {
    return this.getMortality$Response(params, context).pipe(
      map((r: StrictHttpResponse<MortalityResponse>): MortalityResponse => r.body)
    );
  }

  /** Path part for operation `putMortality()` */
  static readonly PutMortalityPath = '/api/harvests/{harvestId}/mortality';

  /**
   * Put Mortality.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putMortality()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putMortality$Response(params: PutMortality$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MortalityTableRow>>> {
    return putMortality(this.http, this.rootUrl, params, context);
  }

  /**
   * Put Mortality.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putMortality$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putMortality(params: PutMortality$Params, context?: HttpContext): Observable<Array<MortalityTableRow>> {
    return this.putMortality$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<MortalityTableRow>>): Array<MortalityTableRow> => r.body)
    );
  }

  /** Path part for operation `getMortalityAnalysisData()` */
  static readonly GetMortalityAnalysisDataPath = '/api/harvests/{harvestId}/mortality-analysis-data';

  /**
   * Get Mortality Analysis Data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMortalityAnalysisData()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMortalityAnalysisData$Response(params: GetMortalityAnalysisData$Params, context?: HttpContext): Observable<StrictHttpResponse<MortalityAnalysisResponse>> {
    return getMortalityAnalysisData(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Mortality Analysis Data.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMortalityAnalysisData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMortalityAnalysisData(params: GetMortalityAnalysisData$Params, context?: HttpContext): Observable<MortalityAnalysisResponse> {
    return this.getMortalityAnalysisData$Response(params, context).pipe(
      map((r: StrictHttpResponse<MortalityAnalysisResponse>): MortalityAnalysisResponse => r.body)
    );
  }

  /** Path part for operation `getMortalityWidgetResponse()` */
  static readonly GetMortalityWidgetResponsePath = '/api/harvests/{harvestId}/mortality-widget';

  /**
   * Get Mortality Widget Response.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMortalityWidgetResponse()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMortalityWidgetResponse$Response(params: GetMortalityWidgetResponse$Params, context?: HttpContext): Observable<StrictHttpResponse<MortalityWidgetResponse>> {
    return getMortalityWidgetResponse(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Mortality Widget Response.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMortalityWidgetResponse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMortalityWidgetResponse(params: GetMortalityWidgetResponse$Params, context?: HttpContext): Observable<MortalityWidgetResponse> {
    return this.getMortalityWidgetResponse$Response(params, context).pipe(
      map((r: StrictHttpResponse<MortalityWidgetResponse>): MortalityWidgetResponse => r.body)
    );
  }

}
